import React, { useState, useMemo, useCallback } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";

import { PiUserSquare } from "react-icons/pi";
import { BsPin, BsPinAngleFill } from "react-icons/bs";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

import { isCategory, isColor } from "../common/function/project";
import { ProjectListContents } from "../common/styled/project";

const Projects = ({ gbn, changeCompany, selectCompany, projects, projectPinned }) => {
  const navigate = useNavigate();
  const company = useSelector((state) => state?.company?.data);

  const [isProjectsOpen, setIsProjectsOpen] = useState({
    fixedProjectList: true,
    cmpnyProjectList: true,
    otherProjectList: true,
    groupProjectList: true,
  });

  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const isTablet = useMediaQuery({ query: "(max-width:1050px)" });
  const isInner = useMediaQuery({ query: "(max-width:1400px)" });

  const getColumnsPerRow = useCallback(() => {
    if (isMobile) return 2;
    if (isTablet) return 3;
    if (isInner) return 4;
    return 5;
  }, [isMobile, isTablet, isInner]);

  const calcHeight = useCallback(
    (length) => {
      const itemHeight = 128;
      const gap = 20;

      if (!length) return 0;

      const columnsPerRow = getColumnsPerRow();
      const lines = Math.ceil(length / columnsPerRow);
      return lines * itemHeight + (lines - 1) * gap;
    },
    [getColumnsPerRow],
  );

  // 이벤트
  const handleToggleSection = useCallback((sectionGbn) => {
    setIsProjectsOpen((prev) => ({
      ...prev,
      [sectionGbn]: !prev[sectionGbn],
    }));
  }, []);

  const handleProjectClick = useCallback(
    (projectNo) => {
      navigate(`/mypage/project/${projectNo}`);
    },
    [navigate],
  );

  const handleCompanyChange = useCallback(
    (e) => {
      changeCompany(e);
    },
    [changeCompany],
  );

  // 현재 섹션의 프로젝트 목록과 관련 데이터
  const currentProjects = projects[gbn] || [];
  const hasProjects = currentProjects.length > 0;
  const isOpen = isProjectsOpen[gbn];
  const sectionHeight = isOpen ? calcHeight(currentProjects.length) : 0;

  // 회사 선택 렌더링 헬퍼
  const renderCompanySelector = () => {
    if (gbn !== "cmpnyProjectList" || !company?.length) return null;

    return (
      <select onChange={handleCompanyChange} value={selectCompany?.cmpnyNo || ""}>
        {company.map((item) => (
          <option key={item.cmpnyNo} value={item.cmpnyNo}>
            {item.cmpnyNm}
          </option>
        ))}
      </select>
    );
  };

  // 즐겨찾기 버튼 렌더링
  const renderFavoriteButton = (project) => {
    if (!project.projectParticipantNo) return null;

    return (
      <button
        className="favorite"
        onClick={(e) => projectPinned(e, project)}
        aria-label={`${project.projectNm} 즐겨찾기`}>
        {gbn.includes("fixed") ? <BsPinAngleFill style={{ color: "#e72e2e" }} /> : <BsPin />}
      </button>
    );
  };

  // 메시지 카운트 렌더링
  const renderMessageCount = (unReadMsgCnt) => {
    if (unReadMsgCnt <= 0) return null;

    return <div className="msgCnt">{unReadMsgCnt > 99 ? "99+" : unReadMsgCnt}</div>;
  };

  return (
    <ProjectListContents key={gbn}>
      <div className="label">
        <div>
          <span>{isCategory(gbn)}</span>
          {renderCompanySelector()}
        </div>
        {hasProjects && (
          <button
            onClick={() => handleToggleSection(gbn)}
            aria-label={`${isCategory(gbn)} 섹션 ${isOpen ? "접기" : "펼치기"}`}>
            {isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
          </button>
        )}
      </div>
      <ul style={{ height: sectionHeight }}>
        {currentProjects.map((project, index) => (
          <li
            key={project.projectNo || index}
            style={{ borderLeft: `7px solid ${isColor(gbn)}` }}
            onClick={() => handleProjectClick(project.projectNo)}>
            {renderFavoriteButton(project)}

            <p style={{ textDecoration: project.completeYn === "Y" ? "line-through" : "none" }}>
              {project.projectNm}
            </p>
            <div className="footer">
              <div className="userCnt">
                <PiUserSquare />
                <span>{project.partiCnt}</span>
              </div>
              {renderMessageCount(project.unReadMsgCnt)}
            </div>
          </li>
        ))}
      </ul>
    </ProjectListContents>
  );
};

export default Projects;
